import styled from 'styled-components';

import StarBall from '@sorare/core/src/atoms/icons/StarBall';

const IconWrapper = styled.span`
  height: var(--triple-unit);
  margin-left: var(--unit);
  display: inline-flex;
  vertical-align: super;
`;

type Props = {
  size?: number;
};

export const StarBallExponent = ({ size = 24 }: Props) => (
  <IconWrapper>
    <StarBall width={size} height={size} color="var(--c-neutral-1000)" />
  </IconWrapper>
);
